export default __webpack_public_path__ + "static/media/new.44c3d58c.svg";